export function isSecretVariable(variable) {
    return variable.type === 'secret';
}
export function redactVariables(variables, values) {
    const redacted = {};
    for (const variable of variables) {
        const value = values[variable.name];
        if (!isSecretVariable(variable) && value !== undefined)
            redacted[variable.name] = value;
    }
    return redacted;
}
export function validateVariableDefinitions(variables) {
    const errors = [];
    const seen = new Set();
    // Prompt authors commonly use Chinese (or other Unicode) names. Keep the
    // same safe identifier boundary as the API while avoiding an ASCII-only UX.
    const variableNamePattern = /^\p{L}[\p{L}\p{N}_]{0,63}$/u;
    for (const variable of variables) {
        if (!variableNamePattern.test(variable.name))
            errors.push(`${variable.name}: invalid name`);
        if (seen.has(variable.name))
            errors.push(`${variable.name}: duplicate`);
        seen.add(variable.name);
        if (variable.type === 'select' && (!variable.options || variable.options.length === 0))
            errors.push(`${variable.name}: options required`);
    }
    return errors;
}
